import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import "./TransactionTable.css";
import {
  Badge,
  Box,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  root1: {
    width: "100%",
    maxWidth: 360,
    // backgroundColor: theme.palette.background.paper,
  },
  chip: {
    margin: theme.spacing(0.5),
    display: "flex",
  },
  chipSecondary: {
    backgroundColor: "green",
  },
  section1: {
    // margin: theme.spacing(3, 2),
  },
  section2: {
    // margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
}));

export default function MiniStatementList(props) {
  const classes = useStyles();

  // Getting Accounts Info
  let transactions;
  let availableBalance;
  let accountNo;
  let masked_accountNo;
  let balance;
  let type;
  // let miniStatementInfo = props.miniStatementData.map((item, i) => {
  //   // console.log("item from Transaction Table: ", item);
  //   transactions = item.Body.Payload.Collection;
  //   availableBalance = item.Body.Payload.Available_Balance;
  //   // balance = parseFloat(availableBalance);

  //   if (availableBalance.includes("CR") || availableBalance.includes("DR")) {
  //     let position = availableBalance.includes("CR")
  //       ? availableBalance.search("CR")
  //       : availableBalance.search("DR");
  //     // console.log("position: ", position);
  //     type = availableBalance.substring(position);
  //     // console.log();
  //     balance = parseFloat(availableBalance).toFixed(2) + " " + type;
  //   } else {
  //     balance = parseFloat(availableBalance).toFixed(2);
  //   }
  //   accountNo = item.Body.Payload.Account_No;
  //   // str.replace(/\d(?=\d{4})/g, "*");
  //   masked_accountNo = accountNo.replace(/\d(?=\d{4})/g, "X");
  // });

  return (
    <div className="ms-wrapper ms-wrapper-bot ms-wrapper-border ms-width-70"
    style={{ border: "8px solid rgba(244, 176, 53, 0.8)"}}>
      <Box>
        <Typography align="center" variant="subtitle2" display="block" className="ministatement">
          Mini Statement
        </Typography>
      </Box>
      <div className={classes.root}>
        <div className={classes.section1}>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="subtitle2">
                A/c Number
              </Typography>
            </Grid>
            <Grid item>
              <Typography gutterBottom variant="subtitle1">
                {masked_accountNo}
              </Typography>
            </Grid>
          </Grid>
          <Grid container alignItems="center">
            <Grid item xs>
              <Typography gutterBottom variant="subtitle2">
                Available Balance
              </Typography>
            </Grid>
            <Grid item>
              <Typography gutterBottom variant="subtitle1">
                {/* ₹ {parseFloat(availableBalance).toFixed(2)} */}₹ {balance}
              </Typography>
            </Grid>
          </Grid>
        </div>
        <Divider variant="middle" />
        {transactions.map((transactions, i) => (
          <div key={i} className={classes.section2}>
            <Paper>
              <Grid container alignItems="center">
                <Grid item xs>
                  <List className={classes.root1}>
                    <ListItem>
                      <ListItemText
                        // primary={transactions.Value_Date}
                        primary={`${
                          transactions.Value_Date.substring(0, 2) +
                          "-" +
                          new Date(
                            `${transactions.Value_Date.substring(2, 4)}`
                          ).toLocaleDateString("en-GB", { month: "short" }) +
                          "-" +
                          transactions.Value_Date.substring(4, 8)
                        }`}
                        secondary={transactions.Narration}
                      />
                    </ListItem>
                  </List>
                </Grid>
                <Grid item>
                  <List className={classes.root1}>
                    <ListItem>
                      {/* <ListItemText
                        primary={parseFloat(transactions.Curr_Balance).toFixed(2)}
                        secondary={transactions.Type_Of_Txn}
                      /> */}
                      <ListItemText
                        primary={
                          <Chip
                            className={classes.chip}
                            color="primary"
                            label={`₹ ${parseFloat(transactions.Amount).toFixed(
                              2
                            )}`}
                          />
                        }
                        secondary={
                          <Chip
                            className={classes.chip}
                            // color="secondary"
                            color={`${
                              transactions.Type_Of_Txn == "CR"
                                ? "default"
                                : "secondary"
                            }`}
                            // label={`₹ ${parseFloat(
                            //   transactions.Curr_Balance
                            // ).toFixed(2)}`}
                            label={`${
                              transactions.Type_Of_Txn == "CR"
                                ? "Credit"
                                : "Debit"
                            }`}
                          />
                        }
                      />
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Paper>
            <Divider variant="middle" />
          </div>
        ))}
      </div>
    </div>
  );
}
